import Reflux from "reflux";
import Immutable, { fromJS } from "immutable";
import UIActions from "../actions/UIActions";

const ImageUploadStore = Reflux.createStore({
  storeName: 'ImageUploadStore',
  listenables: UIActions,

  init() {
    this.state = Immutable.fromJS({
      imageUploadOverlay: {
        show: false,
        message: "",
      },
    });
  },

  getState() {
    return this.state;
  },

  onShowImageUploadOverlay(data) {
    const message = data?.message;
    this.state = this.state.set("imageUploadOverlay", fromJS({ show: true, message }));
    this.trigger(this.state);
  },

  onHideImageUploadOverlay() {
    this.state = this.state.setIn(["imageUploadOverlay", "show"], false);
    this.trigger(this.state);
  },
});

export default ImageUploadStore;
